import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { width, colors, sizes, helpers, media } from 'styles/variables';
import GO from 'utils/GO';

export default props => {
	const lang = props.pageContext.lang || '';
	const [usp] = useState(require(`data/${lang}_usp`));
	const [screenshots] = useState(require(`data/_screenshots`));

	useEffect(() => {
		if (document.querySelectorAll('#screenshotsWrapper').length) {
			document.querySelectorAll('#screenshotsWrapper')[0].style = `width:calc(100% + ${(Math.max(
				document.documentElement.clientWidth,
				window.innerWidth || 0,
				document.querySelector('body').clientWidth,
			) -
				width.max) /
				2}px)`;
		}
	});

	const Wrapper = styled.div`
		display: grid;
		grid-auto-flow: row;
		grid-gap: ${sizes[2]};
		position: relative;
		min-height: 500px;
		${media.notlarge} {
			min-height: 330px;
		}
	`;
	const Screenshots = styled.div`
		position: absolute;
		display: grid;
		grid-auto-flow: column;
		grid-gap: ${sizes[1]};
		overflow: auto;
		width: calc(100% + 50px);
		${media.notlarge} {
			width: calc(100% + ${sizes[2]} + ${sizes[2]}) !important;
			margin: 0 -${sizes[2]};
			padding: 0 ${sizes[2]};
		}

		div {
			width: 230px;
			height: 500px;
			${media.notlarge} {
				width: 150px;
				height: 330px;
			}
			border-radius: 20px;
		}
	`;
	const Item = styled.div`
		display: grid;
		border-radius: ${sizes[0]};
		overflow: hidden;
		${helpers.shadow};
		background-color: ${colors.pink.base};
		align-content: center;
		grid-template-columns: repeat(2, 1fr);
		div {
			background-size: auto calc(100% - ${sizes[2]});
			background-repeat: no-repeat;
			background-position: bottom;
			padding: ${sizes[3]};
			padding-right: 0;
			${media.notsmall} {
				height: 300px;
			}
			${media.small} {
				height: 150px;
			}
			display: grid;
			align-items: center;
			h2 {
				display: block;
				color: ${colors.background[0]};
				font-weight: 600;
				text-align: center;
				${media.notsmall} {
					font-size: 2.5rem;
				}
				${media.small} {
					font-size: 1.25rem;
				}
			}
		}
	`;
	return (
		<>
			<Wrapper>
				<Screenshots id="screenshotsWrapper">
					{screenshots.map((item, index) => (
						<div key={index} style={{ backgroundImage: `url(${item.image.url})` }} />
					))}
				</Screenshots>
			</Wrapper>
		</>
	);
};
